import React from 'react';
import Terminal from './Terminal';
import aboutPic from '../assets/about.jpg';

export default function Hero({ onOpenRecruiter }) {
  return (
    <section id="hero" className="reveal" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', padding: '130px 0 90px', position: 'relative', overflow: 'visible' }}>
      <div className="hero-wm">VIKASH</div>
      <div className="hgrid">
        {/* LEFT */}
        <div className="hleft">
          <div className="htag">Full Stack · Backend · AI/ML</div>
          <h1 className="hname">
            <span>VIKASH</span>
            <span>GAUTAM</span>
          </h1>
          <div className="hrole">
            Building <em>systems that scale</em>-<br />
            from railways to research.
          </div>
          <div className="hcopy">
            <svg width="11" height="11" viewBox="0 0 12 12" style={{ marginRight: '5px' }}>
              <circle cx="6" cy="6" r="5" stroke="var(--accent-color)" strokeWidth="1" fill="none" />
              <text x="6" y="9.5" textAnchor="middle" fontSize="7" fill="var(--accent-color)" fontFamily="serif">©</text>
            </svg>
            Govt. of India Copyright · L-151429/2024
          </div>
          <p className="hdesc">
            Full Stack developer with production experience- 5+ live applications for government and private sector. Optimized a public sector railway system: login <strong style={{ color: 'var(--text-primary)' }}>60s→5s</strong>, data fetch <strong style={{ color: 'var(--text-primary)' }}>2min→10s</strong>.
          </p>
          <div className="hacts">
            <div className="av-wrap">
              <div className="av-pulse"></div>
              <div className="av-pulse"></div>
              <a href="#projects" className="av-btn" style={{ width: '152px' }}>
                <div className="av-border"></div>
                <div className="av-bg"></div>
                <div className="av-sheen"></div>
                <span className="av-label">
                  <span className="av-dot"></span>SEE MY WORK
                </span>
              </a>
            </div>
            <a href="mailto:gautam7.ven@gmail.com" className="btn-g">Get In Touch</a>
            <button onClick={onOpenRecruiter} className="btn-g" style={{ gap: '6px' }}>💼 Recruiter Panel</button>
          </div>
          <div className="hcontacts">
            <a href="mailto:gautam7.ven@gmail.com" className="hci">
              <svg className="hci-icon" viewBox="0 0 14 14" fill="none">
                <rect x="1" y="3" width="12" height="8" rx="1" stroke="var(--accent-color)" strokeWidth="1.2" />
                <path d="M1 4l6 4 6-4" stroke="var(--accent-color)" strokeWidth="1.2" />
              </svg>
              gautam7.ven@gmail.com
            </a>
            <a href="tel:+919307231784" className="hci">
              <svg className="hci-icon" viewBox="0 0 14 14" fill="none">
                <path d="M3 2h2.5l1 3L5 6.5s1 2 2.5 2.5L9 7.5l3 1V11c0 1-4 2-7-1S2 3 3 2z" stroke="var(--accent-color)" strokeWidth="1.1" />
              </svg>
              +91 93072 31784
            </a>
            <span className="hci">
              <svg className="hci-icon" viewBox="0 0 14 14" fill="none">
                <path d="M7 1C4.8 1 3 2.8 3 5c0 3.5 4 8 4 8s4-4.5 4-8c0-2.2-1.8-4-4-4z" stroke="var(--accent-color)" strokeWidth="1.2" />
                <circle cx="7" cy="5" r="1.2" fill="var(--accent-color)" />
              </svg>
              Nagpur, India
            </span>
            <a href="https://linkedin.com/in/vikash2808" className="hci" target="_blank" rel="noreferrer">
              <svg className="hci-icon" viewBox="0 0 14 14" fill="none">
                <rect x="1" y="1" width="12" height="12" rx="2" stroke="var(--accent-color)" strokeWidth="1.1" />
                <path d="M4 6v4M4 4.5v.1M6.5 10V7.5c0-1 .5-1.5 1.5-1.5s1.5.5 1.5 1.5V10" stroke="var(--accent-color)" strokeWidth="1.1" strokeLinecap="round" />
              </svg>
              linkedin.com/in/vikash2808
            </a>
          </div>
        </div>
        
        {/* RIGHT */}
        <div className="hright reveal d2">
          <Terminal />
        </div>
      </div>
    </section>
  );
}